// extracted by mini-css-extract-plugin
export default {"container":"kF-z","modal":"lF-z","dimensions":"mF-z","brandName":"nF-z","productName":"oF-z","labelValue":"pF-z","recipientEmail":"qF-z","recommendedFit":"rF-z","hiddenField":"sF-z"};